import SlButton from '@shoelace-style/shoelace/components/button/button.component';
import {notNull} from '../../../../../../../library/clxProductNet/assets/js/modules/common/assert';

declare global {
    interface Window {
        homieBot?: {
            open: () => void;
        };
    }
}

export default class HomieAi {
    private readonly enableButton: SlButton | null;
    private readonly scriptTag: HTMLScriptElement | null;
    constructor() {
        this.enableButton = document.querySelector<SlButton>('.homie-ai-enable-button');
        this.scriptTag = document.querySelector<HTMLScriptElement>('script#homie-ai-script');

        // button is toggled by feature flag
        if (!this.enableButton) {
            return;
        }

        this.enableButton.addEventListener('click', this.onEnableButtonClick.bind(this));
    }

    private onEnableButtonClick(): void {
        // if homie is already loaded
        if (window.homieBot) {
            this.onScriptLoad();
            return;
        }

        const scriptTag = notNull(this.scriptTag);
        scriptTag.addEventListener('load', this.onScriptLoad.bind(this), {once: true});

        // trigger script load
        scriptTag.src = notNull(scriptTag.dataset.src);
        delete this.scriptTag?.dataset.src;
    }

    private async onScriptLoad() {
        await this.waitForHomieBotInitialized();

        notNull(window.homieBot).open();
    }

    private async waitForHomieBotInitialized(): Promise<void> {
        return new Promise((resolve) => {
            const checkInterval = setInterval(() => {
                if (window.homieBot) {
                    clearInterval(checkInterval);
                    resolve();
                }
            }, 20);
        });
    }
}
